export default "__VITE_ASSET__UeQhW7rT__"